export const CLEAR_CLIENTES = 'CLEAR_CLIENTES';
export const CLEAR_COLABORADORES = 'CLEAR_COLABORADORES';
export const CLEAR_PROFORMAS = 'CLEAR_PROFORMAS';
export const CLEAR_VENDEDORES = 'CLEAR_VENDEDORES';
export const ENTREGA_FILIALES = 'ENTREGA_FILIALES';
export const FETCH_AREAS_VENTA = 'FETCH_AREAS_VENTA';
export const FETCH_AUTORIZACIONES = 'FETCH_AUTORIZACIONES';
export const FETCH_CLIENTES = 'FETCH_CLIENTES';
export const FETCH_COLABORADORES = 'FETCH_COLABORADORES';
export const FETCH_COLORES = 'FETCH_COLORES';
export const FETCH_COMPANIAS = 'FETCH_COMPANIAS';
export const FETCH_CONDICIONES = 'FETCH_CONDICIONES';
export const FETCH_ESTADO_CANCELACION = 'FETCH_ESTADO_CANCELACION';
export const FETCH_ESTADO_GENERAL_LUGARENTREGA = 'FETCH_ESTADO_GENERAL_LUGARENTREGA';
export const FETCH_ESTADO_GENERAL_MOTIVORECHAZO = 'FETCH_ESTADO_GENERAL_MOTIVORECHAZO';
export const FETCH_ESTADO_GENERAL_PLANIF = 'FETCH_ESTADO_GENERAL_PLANIF';
export const FETCH_ESTADO_GENERAL_TIPOENTREGA = 'FETCH_ESTADO_GENERAL_TIPOENTREGA';
export const FETCH_ESTADO_GENERAL_TIPOPLACA = 'FETCH_ESTADO_GENERAL_TIPOPLACA';
export const FETCH_ESTADO_GENERAL_TRANSP = 'FETCH_ESTADO_GENERAL_TRANSP';
export const FETCH_ESTADO_PEDIDO = 'FETCH_ESTADO_PEDIDO';
export const FETCH_ESTADOS = 'FETCH_ESTADOS';
export const FETCH_FAMILIAS = 'FETCH_FAMILIAS';
export const FETCH_FAMILIAS_X_AREAVTA = 'FETCH_FAMILIAS_X_AREAVTA';
export const FETCH_FAMILIAS_SKU = 'FETCH_FAMILIAS_SKU';
export const FETCH_CONFIGURACION = 'FETCH_CONFIGURACION';//88181
export const FETCH_FICHA_VENTA = 'FETCH_FICHA_VENTA';
export const FETCH_FICHAS_VENTA = 'FETCH_FICHAS_VENTA';
export const FETCH_FILIALES = 'FETCH_FILIALES';
export const FETCH_FILIALES_X_ZONAS = 'FETCH_FILIALES_X_ZONAS';
export const FETCH_FILIALES_X_ZONAS_X_AREAS = 'FETCH_FILIALES_X_ZONAS_X_AREAS';
export const FETCH_HISTORIAL = 'FETCH_HISTORIAL';
export const FETCH_HISTORIAL_FDV = 'FETCH_HISTORIAL_FDV';
// TIPO DE ACTIVIDAD
export const FETCH_TIPO_ACTIVIDAD = 'FETCH_TIPO_ACTIVIDAD';
export const FETCH_EVENTO_ACTIVIDAD = 'FETCH_EVENTO_ACTIVIDAD';

// PENDIENTES DE VSEARCH
export const FETCH_PENDIENTES_VSEARCH = 'FETCH_PENDIENTES_VSEARCH';

export const FETCH_LISTA_COLORES = 'FETCH_LISTA_COLORES';
export const FETCH_LISTA_USOS = 'FETCH_LISTA_USOS';
export const FETCH_MARCAS = 'FETCH_MARCAS';
export const FETCH_TIPOVEHICULOS = 'FETCH_TIPOVEHICULOS';//88181
export const FETCH_MARCAS_X_FAMILIA = 'FETCH_MARCAS_X_FAMILIA';
export const FETCH_MONEDAS = 'FETCH_MONEDAS';
export const FETCH_PROFORMA = 'FETCH_PROFORMA';
export const FETCH_PROFORMAS = 'FETCH_PROFORMAS';
export const FETCH_TIPOADQUISICION = 'FETCH_TIPOADQUISICION';
export const FETCH_TIPOFICHAS = 'FETCH_TIPOFICHAS';
export const FETCH_TIPOPAGOS = 'FETCH_TIPOPAGOS';
export const FETCH_USOS = 'FETCH_USOS';
export const FETCH_VENDEDORES = 'FETCH_VENDEDORES';
export const FETCH_ZONAS = 'FETCH_ZONAS';
export const LOADING_FICHAS_VENTA = 'LOADING_FICHAS_VENTA';
export const SEARCH_PEDIDOS = 'SEARCH_PEDIDOS';
export const SEARCH_PROFORMAS = 'SEARCH_PROFORMAS';
export const FETCH_PEDIDOS = 'FETCH_PEDIDOS';
export const FETCH_AUTORIZACIONES_EXCEPCIONALES = 'FETCH_AUTORIZACIONES_EXCEPCIONALES';
export const REPROGRAMAR_ADPER = 'REPROGRAMAR_ADPER';
export const LISTA_PROGRAMADAS = 'LISTA_PROGRAMADAS';
export const PROGRAMAR_PLANIFICACION = 'PROGRAMAR_PLANIFICACION';
export const REPROGRAMAR_PLANIFICACION = 'REPROGRAMAR_PLANIFICACION';
export const PROGRACION_CALENDAR = 'PROGRACION_CALENDAR';
export const DIAS_TRASLADO = 'DIAS_TRASLADO';
export const FETCH_TIPOAUTORIZACION = 'FETCH_TIPOAUTORIZACION';
export const FETCH_RESPONSABLES = 'FETCH_RESPONSABLES';
export const FETCH_LUGARES_DESPACHO = 'FETCH_LUGARES_DESPACHO';
export const LOAD_MANTENIMIENTO = 'LOAD_MANTENIMIENTO';
export const FETCH_FACTURACION = 'FETCH_FACTURACION';
export const FETCHLUGARES_ENTREGA = 'FETCHLUGARES_ENTREGA';
export const FETCHSKU_CONFIGVEHICULO = 'FETCHSKU_CONFIGVEHICULO';//88181
export const FETCHSKU_EQUIPOVEHICULO = 'FETCHSKU_EQUIPOVEHICULO';//88181
export const FETCHSKU_CARTECVEHICULO = 'FETCHSKU_CARTECVEHICULO';//88181
export const FETCHSKU_ESPTECVEHICULO = 'FETCHSKU_ESPTECVEHICULO';//88181
export const FETCHSKU_ACCADUVEHICULO = 'FETCHSKU_ACCADUVEHICULO';//88181
export const FETCHSKU_IMGVEHICULO = 'FETCHSKU_IMGVEHICULO';//88181
export const FETCHSKU_EQUISEGVEHICULO = 'FETCHSKU_EQUISEGVEHICULO';//88181
export const FETCHSKU_INSERT_EQUISEGVEH = 'FETCHSKU_INSERT_EQUISEGVEH';//88181
export const FETCHSKU_DELETE_EQUISEGVEH = 'FETCHSKU_DELETE_EQUISEGVEH';//88181
export const FETCHSKU_INSERT_IMAGENVEH = 'FETCHSKU_INSERT_IMAGENVEH';//88181
export const FETCHSKU_INSERT_IMAGENVEH_ECOMMERCE = 'FETCHSKU_INSERT_IMAGENVEH_ECOMMERCE';
export const FETCHSKU_DELETE_IMAGENVEH = 'FETCHSKU_DELETE_IMAGENVEH';//88181
export const FETCHSKU_LIST_TIPOIMAGEN = 'FETCHSKU_LIST_TIPOIMAGEN';//88181
export const FETCHSKU_LIST_TIPOIMAGEN_ECOMMERCE = 'FETCHSKU_LIST_TIPOIMAGEN_ECOMMERCE';
export const FETCHSKU_RUTA_FIREBASE = 'FETCHSKU_RUTA_FIREBASE';//88181
export const FETCHSKU_CODAUTO_IMAGEN = 'FETCHSKU_CODAUTO_IMAGEN';//88181
export const FETCHSKU_LIST_CONFIGURACION = 'FETCHSKU_LIST_CONFIGURACION';//88181
export const FETCHSKU_LIST_MODELO = 'FETCHSKU_LIST_MODELO';//88181
export const FETCHSKU_UPDATE_CARTECVEH = 'FETCHSKU_UPDATE_CARTECVEH';//88181
export const FETCHSKU_UPDATE_EQUISEGVEH = 'FETCHSKU_UPDATE_EQUISEGVEH';//88181
export const FETCHSKU_UPDATE_EQUIVEH = 'FETCHSKU_UPDATE_EQUIVEH';//90364
export const FETCHSKU_UPDATE_IMAGENVEH = 'FETCHSKU_UPDATE_IMAGENVEH';//88181
export const FETCHSKU_INSERT_CARTECVEH = 'FETCHSKU_INSERT_CARTECVEH';//88181
export const FETCHSKU_LIST_TBCARACTECNI = 'FETCHSKU_LIST_TBCARACTECNI';//88181
export const FETCHSKU_DELETE_CARTECVEH = 'FETCHSKU_DELETE_CARTECVEH';//88181
export const FETCHSKU_LIST_COLORVEHICULOSKU = 'FETCHSKU_LIST_COLORVEHICULOSKU';//90364
export const FETCHSKU_LIST_COLORVEHICULOINTSKU = 'FETCHSKU_LIST_COLORVEHICULOINTSKU';//90364
export const FETCH_INSERT_ADJUNTO = 'FETCH_INSERT_ADJUNTO';
export const FETCH_LISTA_ADJUNTO = 'FETCH_LISTA_ADJUNTO';
export const FETCH_UPDATE_ADJUNTO = 'FETCH_UPDATE_ADJUNTO';
export const FETCH_DELETE_ADJUNTO = 'FETCH_DELETE_ADJUNTO';
export const GET_TIPOS_ARCHIVOS = 'GET_TIPOS_ARCHIVOS';
export const FETCH_FINANCIAMIENTO = 'FETCH_FINANCIAMIENTO';
export const FETCH_CAPACITACION = 'FETCH_CAPACITACION';
export const FETCH_INMATRICULACION = 'FETCH_INMATRICULACION';
export const FETCH_INMATRICULACION_DOCUMENTOS = 'FETCH_INMATRICULACION_DOCUMENTOS';
export const FETCH_INMATRICULACION_SITUACION = 'FETCH_INMATRICULACION_SITUACION';
export const CLEAR_SITUACIONES = 'CLEAR_SITUACIONES';
export const FETCH_DIAS_ENTREGA = 'FETCH_DIAS_ENTREGA';
export const FETCH_UBICACION_PEDIDO = 'FETCH_UBICACION_PEDIDO';
export const FETCH_TIPO_FILIAL_ENTREGA = 'FETCH_TIPO_FILIAL_ENTREGA';
export const FETCH_FACTURACION_EDIT = 'FETCH_FACTURACION_EDIT';
export const FETCH_PEDIDOS_FECHAS = 'FETCH_PEDIDOS_FECHAS';
export const FETCH_PROVEEDOR_CARROCERO = 'FETCH_PROVEEDOR_CARROCERO';
export const FETCH_SUCURSALES = 'FETCH_SUCURSALES';
export const FETCH_BONOS = 'FETCH_BONOS';
export const FETCH_CAPACIDADES = 'FETCH_CAPACIDADES';
export const FETCH_EQUIPOS_LOGISTICA = 'FETCH_EQUIPOS_LOGISTICA';
export const FETCH_EQUIPOS_LOGISTICA_DETALLE = 'FETCH_EQUIPOS_LOGISTICA_DETALLE';
export const FETCH_FORMA_PAGO = 'FETCH_FORMA_PAGO';
export const FETCH_TIPO_DOCUMENTO = 'FETCH_TIPO_DOCUMENTO';
export const FETCH_DOCUMENTO_DESCARGAR = 'FETCH_DOCUMENTO_DESCARGAR';
export const FETCH_ENTIDAD_FINANCIERA = 'FETCH_ENTIDAD_FINANCIERA';
export const FETCH_GESTION_COSTO = 'FETCH_GESTION_COSTO';
export const FETCH_DIRECCIONES_CLIENTE = 'FETCH_DIRECCIONES_CLIENTE';
export const CLEAR_CONDICIONES = 'CLEAR_CONDICIONES';
export const CLEAR_USOS = 'CLEAR_USOS';
export const CLEAR_COLORES = 'CLEAR_COLORES';
export const CLEAR_PROFORMAS_BUSCAR = 'CLEAR_PROFORMAS_BUSCAR';
export const FETCH_TIPO_ADICIONAL = 'FETCH_TIPO_ADICIONAL';
export const CLEAR_PEDIDOS_BUSCAR = 'CLEAR_PEDIDOS_BUSCAR';
export const FETCH_PROVEEDOR_LIST_ADDITIONAL_EQUIPMENT = 'FETCH_PROVEEDOR_LIST_ADDITIONAL_EQUIPMENT';
export const FETCH_REPORTE_FDV = 'FETCH_REPORTE_FDV';
export const FETCH_REPORTE_EXCEL_FDV = 'FETCH_REPORTE_EXCEL_FDV';
export const FETCH_EQUIPOS_CORTESIA = 'FETCH_EQUIPOS_CORTESIA';
export const FETCH_MAESTRO_TIPO_SOLICITUD_FACTURACION = 'FETCH_MAESTRO_TIPO_SOLICITUD_FACTURACION';
export const FETCH_FACTURACION_GRABAR = 'FETCH_FACTURACION_GRABAR';
export const FETCH_CONTACTOS_CLIENTES = 'FETCH_CONTACTOS_CLIENTES';
export const FETCH_PEDIDOS_COLORES = 'FETCH_PEDIDOS_COLORES';
export const FETCH_PEDIDOS_USO = 'FETCH_PEDIDOS_USO';
export const FETCH_PROFORMA_COLOR = 'FETCH_PROFORMA_COLOR';
export const FETCH_COLORES_GET = 'FETCH_COLORES_GET';
export const FETCH_USO_GET = 'FETCH_USO_GET';
export const FETCH_EQUIPOS_LOGISTICA_GRABAR = 'FETCH_EQUIPOS_LOGISTICA_GRABAR';
export const FETCH_GRABAR_HISTORIAL_FDV = 'FETCH_GRABAR_HISTORIAL_FDV';
export const FETCH_AUTORIZACIONES_USUARIOS = 'FETCH_AUTORIZACIONES_USUARIOS';
export const SAVE_AUTORIZACIONES_EXCEPCIONALES = 'SAVE_AUTORIZACIONES_EXCEPCIONALES';
export const FETCH_SEGUIMIENTO_AUTORIZACIONES = 'FETCH_SEGUIMIENTO_AUTORIZACIONES';
export const SAVE_GENERAR_CORREO_AUTORIZACIONES = 'SAVE_GENERAR_CORREO_AUTORIZACIONES';
export const FETCH_ASIGNACION_DEFINITIVA = 'FETCH_ASIGNACION_DEFINITIVA';
export const SAVE_PEDIDOS_COLOR = 'SAVE_PEDIDOS_COLOR';
export const SAVE_PEDIDOS_USO = 'SAVE_PEDIDOS_USO';
export const FETCH_REGLAS_NEGOCIO = 'FETCH_REGLAS_NEGOCIO';
export const FETCH_CLIENTES_PEDIDOS = 'FETCH_CLIENTES_PEDIDOS';
export const FETCH_USUARIOS_APROBADORES = 'FETCH_APROBADORES';
export const PERMISOS_AUTORIZADOR = 'PERMISOS_AUTORIZADOR';
export const DELETE_PEDIDOS_COLORES = 'DELETE_PEDIDOS_COLORES';
export const FETCH_SOLICITUD_PEDIDOS = 'FETCH_SOLICITUD_PEDIDOS';
export const FETCH_LOGISTICA_COSTO = 'FETCH_LOGISTICA_COSTO';
export const FETCH_MAESTROS = 'FETCH_MAESTROS';
export const FETCH_PERMISOS = 'FETCH_PERMISOS';
export const FETCH_FICHA_VENTA_CORREOS = 'FETCH_FICHA_VENTA_CORREOS';//Req 92528 ebarboza 28 08 2021
export const FVTA_WEL_PACK_PROF_VEH = 'FVTA_WEL_PACK_PROF_VEH';//Req 93426 ebarboza 29 11 2021
export const FETCH_VALIDAR_PROFORMA = 'FETCH_VALIDAR_PROFORMA' //Req 93426 ebarboza 29 11 2021 
export const FETCH_FVTA_WEL_PACK_PROF_VEH = 'FETCH_FVTA_WEL_PACK_PROF_VEH' //Req 93426 ebarboza 29 11 2021
export const REG_FVTA_WEL_PACK_PROF_VEH = 'REG_FVTA_WEL_PACK_PROF_VEH' //Req 93426 ebarboza 29 11 2021


// WEBPACK FOOTER //
// ./src/actions/types.js